import {styled} from 'styled-components'

export const ConfirmationModalContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 1px;
  justify-content: center;

  & span {
    text-align: center;
  }
`
